import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { fromEvent, interval, throttle } from 'rxjs';

@Component({
    template: '', changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EaChartAbstractComponent<T = any> {
  Highcharts: typeof Highcharts = Highcharts;

  @Input() set options(options) {
    this._options = { ...this._options, ...options };
    // this.changeDetectorRef.detectChanges()
  }
  get option() {
    return this._options;
  }
  _options;

  @Input() set series(series) {
    this._series = series;
    this.options = {
      ...this.options,
      series: [{ data: series }],
    };
  }
  get series() {
    return this._series;
  }
  _series = [];
  @Input() showLegend: any = true;
  @Input() showLegendValues: any = true;
  @Input() height: number | string = 220;
  @Input() width: number | string = null;

  @Input() valueSuffix = '€';
  @Input() mouseTracking = false;

  resize: any;
  private timer: any;

  constructor(
    protected translate: TranslateService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    const resizeEvent = fromEvent(window, 'resize');
    this.resize = resizeEvent.pipe(throttle(ev => interval(100)));
    this.resize = this.resize.subscribe(x => {
      let options = Object.assign({}, this._options);
      this._options = undefined;
      setTimeout(() => {
        this._options = {
          ...options,
          plotOptions: {
            ...options.plotOptions,
            series: {
              ...options.plotOptions.series,
              animation: false,
            },
          },
        };
        this.changeDetectorRef.detectChanges();
      }, 10);
    });

    this._options = {
      chart: {
        type: 'line',
        spacingLeft: 0,
        spacingRight: 0,
        height: this.height,
        width: this.width,
        backgroundColor: 'transparent',
      },
      credits: {
        enabled: false,
      },
      colors: [
        '#1E40AF',
        '#F5A800',
        '#33A02C',
        '#FF7F00',
        '#D90000',
        '#C36363',
      ],
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
      },
      yAxis: {
        title: {
          text: '',
        },
        allowDecimals: false,
      },
      legend: {
        enabled: true,
      },
      tooltip: {
        shared: true,
        valueSuffix: this.valueSuffix,
        valueDecimals: 2,
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: !this.mouseTracking,
            format:
              '<b style="color:{point.color}">{point.y:.2f}' +
              this.valueSuffix +
              '</b>',
          },
          enableMouseTracking: this.mouseTracking,
        },
      },
    };
  }
}
